export default __webpack_public_path__ + "static/media/python_icon.81626196.png";